export const environment = 
{
    production: false,
    envName: "teal_health",
    systemUserId: 0,
    harlowe:
    {
        hemi: {
            baseUri: "https://hemi.1.harlowehealth.com"
        },
        tealhealth:
        {
            baseUri: "https://tealhealth.api.test.harlowehealth.com/tealhealth/api",
            coreApiUri: "https://tealhealth.api.test.harlowehealth.com/api",
            auth:
            {
                clientId: "d2bb3f54-0138-47dd-b6d8-6be52e1a08c5",
                authority: "https://login.microsoftonline.com/0c7cab0e-8f19-4bde-a901-4b7b35f056e3/",
                redirectUri: "https://tealhealth.test.harlowehealth.com",
                scopes:
                [
                    'api://d2bb3f54-0138-47dd-b6d8-6be52e1a08c5/Login'
                ]
            },
            signaling:
            {
                endpoints:
                {
                    messaging:"/signaling/messaging",
                    encounters:"/signaling/encounters",
                    referrals:"/signaling/referrals",
                    encounterDiaries:"/signaling/encounters/diaries",
                    encounterAppointments:"/signaling/encounters/appointments",
                    medical:"/signaling/medical",
                    finance:"/signaling/finance",
                    email:"/signaling/email",
                    emailTemplates:"/signaling/email/templates",

                }
            },
            autologin:true,
            domain: "@teal-networks.com"
        }
    }
};
